import React from 'react';
import { messageShow, getLoginShopInfo } from '../../utils/http.js';
import ShowModal from '../showModal/index.jsx';
import MyLoading from '../showLoading/showLoading.jsx';
import $ from 'jquery';
import { batchDistributionRequest, LoadProductSkuMappingV2Request, loadSupplierProduct } from '../../utils/api.js';
import { withRouter } from 'react-router-dom';
import SkuMappingsModule from '../skuMappingsModule/index.jsx';
import "./index.less";

class ChangeProductByAlibaba extends React.Component {
    constructor(props) {
        super(props);
        const changeSupplierProduct = props.changeSupplierProduct;//更换货源的的商品;
        if (changeSupplierProduct) {
            changeSupplierProduct.SourcePlatform = !changeSupplierProduct.SourcePlatform ? 'AlibabaZhuKe' : changeSupplierProduct.SourcePlatform;
        }
        this.state = {
            isLoading: false,
            loadingTitle: '',
            isShowDailog: props.showModal,
            isShowWarnText: false,
            title: "1688低价找货源",
            shopId: 0,
            productId: 0,
            relationApiData: null,
            selectedShopProductImgSrc: props.selectedShopProductImgSrc,
            selectProductId: props.selectProductId,
            changeSupplierProduct: changeSupplierProduct,//更换货源的的商品
            noticeText: "",
        }
    }
    componentDidMount() { //组件挂载到DOM渲染后被执行，只会执行一次。
         //获取登陆信息
         var shopInfo = getLoginShopInfo();
         if (shopInfo.loginShopId == "" || shopInfo.loginShopPlatformType == "") {
           var setIntervalTimer = setInterval(() => {
             shopInfo = getLoginShopInfo();
             if (shopInfo.loginShopId != "" && shopInfo.loginShopPlatformType != "") {
               this.setState({
                 targetShopId: shopInfo.loginShopId,
                 targetShopPt: shopInfo.loginShopPlatformType,
               })
               clearInterval(setIntervalTimer);
             }
           }, 500)
         }
        //添加监听
        window.addEventListener(
            'message',
            (event) => {
                const { data: eventData } = event;
                if (event && eventData && eventData.type === '1688_jxhy_search') {
                    //debugger;
                    console.log(eventData.data) // 消息体如上
                    //监听到数据传商品id到切换货源
                    var id = eventData.data["1688_item_id"];
                    //if(id.includes(','))
                   // {
                   //     messageShow("暂不支持批量操作。", "error");
                    //    return;
                    //}
                    this.chooseMapProductSku(id);
                }
            },
        );
    }

    //关闭弹窗
    closeShowModal = () => {
        this.setState({
            isShowDailog: false,
        });
        this.props.closeChangeProductByAlibaba();

    }
    componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
        if (props.showModal != this.state.isShowDailog && props.showModal == true) {

            let title = this.props.title;
            const changeSupplierProduct = props.changeSupplierProduct;//更换货源的的商品;
            if (changeSupplierProduct) {
                changeSupplierProduct.SourcePlatform = !changeSupplierProduct.SourcePlatform ? 'AlibabaZhuKe' : changeSupplierProduct.SourcePlatform;
            }
            var shopInfo = getLoginShopInfo();
            this.setState({
                changeSupplierProduct: changeSupplierProduct,//更换货源的的商品
                selectProductId: props.selectProductId,
                selectedShopProductImgSrc: props.selectedShopProductImgSrc,
                isShowDailog: props.showModal,
                title: title,
                skuMappingsModuleDailog: false,//如果是重新打开，对应规格映射弹窗关闭
                targetShopId: shopInfo.loginShopId,
                targetShopPt: shopInfo.loginShopPlatformType,
            })

           
            //获取相关的商品数据
            const relationData = props.relationData;
            if (props.showModal) {
                this.setState({
                    selectProductId: props.selectProductId,
                    selectedShopProductImgSrc: props.selectedShopProductImgSrc
                }, () => {
                    if (relationData) {
                        this.initData(relationData)
                    } else {
                        this.getSelectProductInfo();  //获取选中商品详细详情
                    }
                })
            }
        }
    }
    //获取地址
    getUrl() {

        var url = "https://air.1688.com/app/channel-fe/search/index.html#/result?isv_appkey=8076003";
        //当前关联商品的店铺id
        //var shopid=this.state.targetShopId;
        //if (shopid != undefined&&shopid!="") {
        //    url += "&isv_out_shop_code="+shopid;
        //}
        //var productId=this.state.selectProductId;
        //if (productId != undefined&&productId!="") {
        //    url += "&isv_out_item_code=" + productId;
        //}
        url += "&isv_distribute_mode=link";
        //所选择的商品图片默认只有一张
        var imgurl = this.state.selectedShopProductImgSrc;
        if (imgurl != undefined && imgurl != "") {
            url += "&image_list=" + encodeURIComponent(imgurl + "?name=test.png");

        }
        return url;

    }
    //确认关联
    chooseMapProductSku = async (item) => {

        this.setState({
            changeSameProduct: null,
            isLoading: true,
            loadingTitle: '获取商品详情中...',
        })
        await this.getSelectSupplierProductInfo(item);//获取同款商品详情
        this.setState({
            isLoading: false,
            loadingTitle: '',
        })
    }
    //加载商品规格信息

    getSelectProductInfo = async () => {
        const data = {
            ShopId: this.state.targetShopId,
            ProductId: this.state.selectProductId
        };
        this.setState({
            selectProduct: null,
            noticeText: '获取信息中...',
            isLoading: true,
            relationApiData: null,
        });
        const res = await LoadProductSkuMappingV2Request(data);
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
        {
            this.setState({ noticeText: '请求超时，请重试。', isLoading: false, });
            messageShow("请求超时，请重试。", "error");
            return;
        }
        this.setState({ noticeText: '', isLoading: false, });
        if (res.Success) {
            this.initData(res.Data)
        } else {
            messageShow("获取商品信息失败"+ res.Message, "error");
        }
    }

    initData = (relationApiData) => {

        const product = relationApiData.ProductFx;
        relationApiData.SupplierProducts = relationApiData.SupplierProducts || []
        relationApiData.Relation = relationApiData.Relation || []

        relationApiData.Relation.forEach(x => {
            x.SkuMappings = x.SkuMappings || []
            x.SkuMappings.forEach(mapping => {
                mapping.SourcePlatform = !mapping.SourcePlatform ? 'AlibabaZhuKe' : mapping.SourcePlatform
                mapping.MappingCount = mapping.MappingCount == 0 ? 1 : mapping.MappingCount//如果发现后台返回值的mappingcount为0，改为1
            })
        })

        relationApiData.SupplierProducts.forEach(supplierProduct => {
            supplierProduct.SourcePlatform = !supplierProduct.SourcePlatform ? 'AlibabaZhuKe' : supplierProduct.SourcePlatform
        })

        if (this.state.changeSupplierProduct) {
            const changeSupplierProduct = this.state.changeSupplierProduct;//需要替换的货源
            const hasIndex = relationApiData.SupplierProducts.findIndex(x => x.SourcePlatform == changeSupplierProduct.SourcePlatform && x.ProductId == changeSupplierProduct.ProductId)
            if (hasIndex != -1) {
                relationApiData.SupplierProducts.splice(hasIndex, 1)
                relationApiData.Relation = relationApiData.Relation.filter(x => x.SourcePlatform != changeSupplierProduct.SourcePlatform || x.SupplierProductId != changeSupplierProduct.ProductId)
            }
        }

        var priceArr = [];
        for (let i = 0; i < product.Skus.length; i++) {
            priceArr.push(product.Skus[i].SalePrice);
            product.Skus[i].SupplierSkuList = null;
        }
        priceArr.sort();
        product.PriceArr = priceArr;
        this.setState({
            selectProduct: product,
            relationApiData: relationApiData,
            selectPlatformTypeRelevance: product.PlatformType
        });
    }

    getSelectSupplierProductInfo = async (item) => {
        var that = this;
        var data = {
            SupplierProductId: item,
            SourcePlatform: 'AlibabaZhuKe'
        };
        const res = await loadSupplierProduct(data);
       
        that.setState({ isShowLoadAction: false, isLoading: false, });

        if (res.Success) {
            var supplierProduct = res.Data.AlibabaProduct;

            //遍历sku获取价格区间,供应商sku列表
            var priceArr = [];
            var supplierProductSkuList = [];
            for (let i = 0; i < supplierProduct.Skus.length; i++) {
                priceArr.push(supplierProduct.Skus[i].ConsignPrice);
                var attrArr = JSON.parse(supplierProduct.Skus[i].Attributes);
                var color = '';
                var size = '';

                for (let n = 0; n < attrArr.length; n++) {
                    if (n == 0) {
                        color = attrArr[n].AttributeValue;
                    } else {
                        size = attrArr[n].AttributeValue;
                    }
                }

                supplierProduct.Skus[i].Color = color
                supplierProduct.Skus[i].Size = size
                supplierProductSkuList.push({
                    label: color + size,
                    value: supplierProduct.Skus[i].SkuId
                });
            }
            priceArr.sort();

            var changeProduct = {
                ImageUrl: supplierProduct.Images[0],
                Subject: supplierProduct.Subject,
                PriceArr: priceArr,
                SupplyStock: supplierProduct.SupplyStock,
                Text: '',
                Status: supplierProduct.Status,
                SupplierLoginId: supplierProduct.SupplierLoginId,
                platformName: supplierProduct.SourcePlatform,
            }
            supplierProduct.SourcePlatform = !supplierProduct.SourcePlatform ? 'AlibabaZhuKe' : supplierProduct.SourcePlatform

            const exists = that.state.relationApiData.SupplierProducts.findIndex(x => x.SourcePlatform == supplierProduct.SourcePlatform && supplierProduct.ProductId == x.ProductId)
            if (exists == -1)
                that.state.relationApiData.SupplierProducts.push(supplierProduct)

            if (typeof this.props.saveSureSupplierProduct == 'function' && this.props.isReturnSelectSupplierProduct == 1) {
                this.closeShowModal()
                this.props.saveSureSupplierProduct(supplierProduct)
            } else {
                that.showSkuMapping()

                that.setState({
                    changeSameProduct: changeProduct,
                    supplierProduct: supplierProduct,
                    supplierProductSkuList: supplierProductSkuList,
                    selectSupplierLoginId: supplierProduct.SupplierLoginId,
                    selectSupplierProductId: supplierProduct.ProductId,
                }, () => {
                    $(".changeProductsWrap .SupplierSkuList-item-select").each((index, item) => { //有默认值时 高亮显示
                        if ($(item).val() != "") {
                            $(item).addClass("active")
                        }
                    })
                });
            }
        } else {
            that.setState({
                noticeText: '非1688一件代发商品或当前商品需要通过厂家审核，请重新输入',
                isShowWarnText: true,
                showNotFoundSupplierProductError: true,
            });
            // app.MessageShow('error', "非1688一件代发商品或当前商品需要通过厂家审核，请重新输入");
        }
    }

    showSkuMapping(product) {
        this.setState({
            skuMappingsModuleDailog: true,
            skuMappingSelectProduct: product,
        })
    }
    closeSkuMappingsModule = () => {
        const supplierProducts = (this.state.relationApiData && this.state.relationApiData.SupplierProducts) || [];
        if (this.state.supplierProduct && supplierProducts.length > 0) {
            const index = supplierProducts.findIndex(x => x.ProductId == this.state.supplierProduct.ProductId)
            if (index > -1) {
                supplierProducts.splice(index, 1)
            }
        }

        this.setState({
            skuMappingsModuleDailog: false,
            skuMappingSelectProduct: null,
        })
    }
    //关联规格
    sureSkuMapping = async (data) => {
        if (this.state.isTempRelevanceProduct == 1) {
            this.props.tempChangeProductSaveSure(data)
        } else {
            this.setState({ isLoading: true })
            const res = await batchDistributionRequest.RelateProductV2(data)
            this.setState({ isLoading: false })
            if (res.Success) {
                messageShow("关联成功，可到代销商品中查看。", 'success');
                this.closeSkuMappingsModule()
                this.closeShowModal()
                this.props.sureRelevanceRequest(data)
            } else {
                messageShow('关联规格失败：'+res.Message,'error')
            }
        }
    }
    
    closeNotFoundAlibabaSupplierProductErrorDailog() {
        this.state.showNotFoundSupplierProductError = false
        this.state.showNotFoundAlibabaSupplierProductError = false
        this.setState({})
      }
    render() {
        const { selectPlatform } = this.state;
        //let selectPlatformName = app.selectPlatformByName(selectPlatform);
        var src = this.getUrl();
       
        return (
            <ShowModal
                showLeftTopBtn={true}
                width={1130}
                showModal={this.state.isShowDailog}
                titleName={this.state.title}
                skin={"changeProductsWrap"}
                hideBtn={true}
                cancelDailog={this.closeShowModal} //取消按钮回调函数

            >
                <iframe className='zk-modal-iframe' src={src} height="100%" width="100%"></iframe>
                <div className='zx-modal-footer-mask'></div>
                <SkuMappingsModule
                    showModal={this.state.skuMappingsModuleDailog}
                    shopId={this.state.selectProduct && this.state.selectProduct.ShopId}
                    platformType={this.state.selectProduct && this.state.selectProduct.PlatformType}
                    relationData={this.state.relationApiData}
                    selectProductSkuId={this.state.selectProductSkuId}
                    closeSkuMappingsModule={this.closeSkuMappingsModule}
                    saveSure={this.sureSkuMapping}
                    titleName='匹配规格'
                ></SkuMappingsModule>
                <MyLoading isLoading={this.state.isLoading} title={this.state.loadingTitle} isShade={true} isStopOperate={true} fullCenter={true} />

                <ShowModal titleName={"货源不支持铺货代发"} showModal={this.state.showNotFoundSupplierProductError} hideTitleBg={true} hideBtn={true} width={'450px'} cancelDailog={() => this.closeNotFoundAlibabaSupplierProductErrorDailog()} showLeftTopBtn={true}
                    titleIcon={<span className='iconfont icon-gantan warnColor' style={{ fontSize: '24px', marginRight: '10px' }}></span>} >
                    <div style={{ fontSize: '16px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <div>
                            <span>该货源未获得分销授权，无法进行铺货、关联、更换。您可以换个货源或者联系供应商将该商品设置为支持分销</span>
                        </div>
                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <span onClick={() => window.open('https://www.yuque.com/jessie-bvwmn/qqsqc7/gtpzq3', '_blank')} className="showModalWrap-box-footer-btn">查看教程</span>
                        <span onClick={() => this.closeNotFoundAlibabaSupplierProductErrorDailog()} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
                    </div>
                </ShowModal>
            </ShowModal>);
    }

}
export default withRouter(ChangeProductByAlibaba);



// WEBPACK FOOTER //
// ./src/components/changeProductByAlibaba/index.jsx